export default __webpack_public_path__ + "static/media/appoinment.072ef5b1.jpg";